module.exports = __webpack_public_path__ + "img/nodata.699621fb.svg";